<template>
	<div>
		<buttonlist
			@help="help"
			@search="search"
			@reflash="reflash"
			@del="del"
			@save="save"
			ref="SetBtn"
		></buttonlist>
		<ul class="Boxs" ref="Box" :style="{ height: tableHeight + 'px' }">
			<li class="left" ref="left">
				<el-table
						id="xpane-0"
						:data="dataSet"
						v-loading="loading"
						:highlight-current-row="true"
						show-overflow-tooltip="true"
						border
						stripe
						size="mini"
						:height="tableHeight"
						@row-click="editInfo"
						@row-dblclick="openEdit"
						:row-class-name="tableRowClassName"
						header-row-class-name="headerclass"
						style="width: 100%; margin-top:0px"
						:header-cell-style="$limits.headerClass"
				>
					<el-table-column type="selection" v-if="false"></el-table-column>
					<el-table-column show-overflow-tooltip prop="conf_room" :label="$t('getapi[13296]')" width="100"></el-table-column>
					<el-table-column show-overflow-tooltip prop="conf_date" :label="$t('getapi[13297]')" width="150"></el-table-column>
					<el-table-column show-overflow-tooltip prop="conf_theme" :label="$t('getapi[13298]')" width="200"></el-table-column>
					<el-table-column show-overflow-tooltip prop="start_time" :label="$t('getapi[6339]')" width="100"></el-table-column>
					<el-table-column show-overflow-tooltip prop="end_time" :label="$t('getapi[4057]')"  width="100"></el-table-column>
					<el-table-column show-overflow-tooltip prop="appt_person" :label="$t('getapi[13299]')"  width="100"></el-table-column>
					<el-table-column show-overflow-tooltip prop="appt_tel" :label="$t('getapi[1202]')"  width="100"></el-table-column>
					<el-table-column show-overflow-tooltip prop="personname" :label="$t('getapi[13300]')"  width="300"></el-table-column>
				</el-table>
			</li>
			<li class="resize" ref="resize">
				<i class="el-icon-caret-right" @click="leftt(0)"></i>
				<i class="el-icon-caret-left" @click="leftt(1)"></i>
			</li>
			<li class="mid" ref="mid">
				<div  style="float:right;position: relative;">
					<el-button type="danger" size="mini" icon="el-icon-close" @click="colseEdit"></el-button>
				</div>
				<table>
					<tr>
						<td>
							<span>{{$t('getapi[13294]')}}</span>
						</td>
						<td>
							<el-input v-model="dataDetail.Head.conf_room" type="text" :disabled="true"></el-input>
						</td>
						<td>
							<span>{{$t('getapi[13297]')}}</span>
						</td>
						<td>
							<el-input v-model="dataDetail.Head.conf_date" type="text" :disabled="true"></el-input>
						</td>
					</tr>
					<tr>
						<td>
							<span>{{$t('getapi[13298]')}}</span>
						</td>
						<td colspan="3">
							<el-input v-model="dataDetail.Head.conf_theme" type="text" :disabled="true"></el-input>
						</td>
					</tr>
					<tr>
						<td>
							<span>{{$t('getapi[6339]')}}</span>
						</td>
						<td>
							<el-date-picker v-model="dataDetail.Head.start_time" type="datetime" :disabled="true"></el-date-picker>
						</td>
						<td>
							<span>{{$t('getapi[4057]')}}</span>
						</td>
						<td>
							<el-date-picker v-model="dataDetail.Head.end_time" type="datetime" :disabled="true"></el-date-picker>
						</td>
					</tr>
					<tr>
						<td>
							<span>{{$t('getapi[13299]')}}</span>
						</td>
						<td>
							<el-input v-model="dataDetail.Head.appt_person" type="text" :disabled="true"></el-input>
						</td>
						<td>
							<span>{{$t('getapi[1202]')}}</span>
						</td>
						<td>
							<el-input v-model="dataDetail.Head.appt_tel" type="text" :disabled="true"></el-input>
						</td>
					</tr>
					<tr>
						<td>
							<span>{{$t('getapi[4126]')}}</span>
						</td>
						<td>
							<el-date-picker v-model="dataDetail.Head.create_time" type="datetime" :disabled="true"></el-date-picker>
						</td>
						<td>
							<span>{{$t('getapi[143]')}}</span>
						</td>
						<td>
							<el-input v-model="dataDetail.Head.remark" type="text" :disabled="true"></el-input>
						</td>
					</tr>
				</table>
				<div class="btnnowrap">
					<el-button type="primary" size="mini" @click="selectemployee" :disabled="dataDetail.Head.unnum == ''">{{ $t('getapi[438]') }}</el-button>
					<el-button type="primary" size="mini" @click="delbatch" :disabled="selectData.length == 0">{{
						$t('getapi[1522]') }}
					</el-button>
				</div>
				<el-table :data="dataDetail.Lists" height="500" size="mini" border
						  style="width: 100%; margin-top:2px" @selection-change="handleSelectionChange"
						  header-row-class-name="headerclass">
					<el-table-column type="selection"></el-table-column>
					<el-table-column show-overflow-tooltip prop="Person" :label="$t('getapi[13300]')" width="100"></el-table-column>
					<el-table-column show-overflow-tooltip prop="userID" :label="$t('getapi[13301]')" width="100"></el-table-column>
					<el-table-column show-overflow-tooltip prop="loginName" :label="$t('getapi[12385]')" width="100"></el-table-column>
				</el-table>
			</li>
		</ul>
		<el-row class="page">
			<el-col :span="18">
				<el-pagination
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:page-sizes="[100, 200, 300, 400]"
					:page-size="100"
					:pager-count="5"
					layout="total, sizes, prev, pager, next, jumper"
					:total="total"
				></el-pagination>
			</el-col>
			<el-col :span="6">
				<div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames }}</div>
			</el-col>
		</el-row>

		<el-dialog v-dialogDrag :title="$t('getapi[1980]')" :visible.sync="showSearch" width="30%">
			<table>
				<tr>
					<td>
						<span>{{$t('getapi[13296]')}}</span>
					</td>
					<td>
						<el-input v-model="Conf_Room" type="text"></el-input>
					</td>
				</tr>
				<tr>
					<td>
						<span>{{$t('getapi[13298]')}}</span>
					</td>
					<td>
						<el-input v-model="Conf_Theme" type="text"></el-input>
					</td>
				</tr>
			</table>
			<span slot="footer" class="dialog-footer">
				<el-button  @click="showSearch = false" size="mini">{{$t('getapi[6]')}}</el-button>
                <el-button type="primary" @click="getView" size="mini">{{$t('getapi[1980]')}}</el-button>
			</span>
		</el-dialog>

		<selector :isVisible="false" :isBatch=true :isSplitPage=true :selectType="1"
				  :postUrl="'/Basic/Popup/GetEmployeeDataList'"
				  @callback="getemployee" ref="employee"></selector>
	</div>
</template>

<script>
import Common from '@/components/Common';
import Array from '@/components/Array';
import { Loading } from 'element-ui';
export default {
	name:'meetingroomlist',
    computed: {
        tableHeight(){
            return this.$windowSize.tableHeight3
        }
    },
	data() {
		return {
            tableHeader: [],
			dataSet: [], // 主表数据
			isVisible: false, // 查询列表是否显示
			queryData: [], // 查询数组
			userData: [], // 用户信息
			DbTbNames: '',
			pageIndex: 1, // 当前页
			pageSize: 100, // 当前页数据量
			SelectIndexs: 1, //当前页面
			total: 0, // 数据总量
			loading: false, // 主表加载状态
            authority_showprice: false,
            scrollTop:0,
            showSearch: false,
            UnNum:'',
            Conf_Theme:'',
            Conf_Room:'',
            dataDetail:{
                Head:{unnum: '',
                    conf_room: '',
                    conf_date: '',
                    conf_theme: '',
                    conf_content: '',
                    start_time: '',
                    end_time: '',
                    show_end_time: '',
                    conf_num: 0,
                    conf_device: '',
                    status: 0,
                    appt_tel: '',
                    appt_percode: '',
                    appt_person: '',
                    appt_time: '',
                    audit_person: '',
                    audit_time: '',
                    audit_opinion: '',
                    remark: '',
                    modify_time: '',
                    create_time: '',
                    datearr:[],},
                Lists:[],
			},
			selectData:'',
		};
	},
    watch:{
        dataSet: function(){
            let that = this
            that.$nextTick(function() {
                that.$processdata.initForm(0)
            })
        },
    },
    beforeRouteEnter(to, form, next) {
        next(vm => {
            if (form.name == 'home' && Object.keys(vm.$store.state.sharedParams).length > 0) {
                const data = {...vm.$store.state.sharedParams};
                vm.getDetail(data.unnum);
                let parm = {
                    Page_Index:vm.pageIndex,
                    Page_Size:vm.pageSize,
                    UnNum: data.unnum,
                    Conf_Theme:'',
                    Conf_Room:'',
                    Status:'',
                }
                vm.$http.urlpost('/Conf/View/ConfList', parm, function(res) {
                    if (res.Success == 1) {
                        vm.dataSet = res.DataContent;
                        vm.total = res.Totals;
                    }
                    vm.showSearch = false
                });
                setTimeout(() => {
                    vm.openEdit()
                }, 500);
                vm.$store.commit('clearSharedParams')
            }
        });
    },
	mounted: function() {
		let that = this;
		that.userData = JSON.parse(sessionStorage.getItem('userData'));
        that.$limits.dragControllerDiv();
		that.authority();
	},
    activated () {
        let that = this
        setTimeout(() => {
            that.$refs.singleTable.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                that.scrollTop = res.target.scrollTop
            },false)
        }, 5000);
        // 路由跳转回来滚动到离开时的位置
        this.$nextTick(()=> {
            setTimeout(() => {
                this.$refs.singleTable.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
            }, 13)
        })
    },
	methods: {
        help(){
            this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[1138]"),this.$t("getapi[16]"));
        },
		authority() {
			let that = this;
            if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                that.$refs.SetBtn.SetOneBtnEnable('help',true);
            }
            that.$refs.SetBtn.SetButtonEnable('search,refresh');
		},
        btnauthority(){
            let that = this
            if((that.dataDetail.Head.status == 0 || that.dataDetail.Head.status == 10) && that.dataDetail.Head.appt_percode.toLowerCase() == that.userData.Login_Code.toLowerCase()){
                that.$refs.SetBtn.SetOneBtnEnable('del',true);
                that.$refs.SetBtn.SetOneBtnEnable('save',true);
            } else {
                that.$refs.SetBtn.SetOneBtnEnable('del',false);
                that.$refs.SetBtn.SetOneBtnEnable('save',false);
            }
		},
        leftt(e) {
            var left = document.getElementsByClassName('left');
            var mid = document.getElementsByClassName('mid');
            var Box = document.getElementsByClassName('Boxs');
            let bw = Box[0].clientWidth;
            if (e == 1) {
                left[0].style.width = '0px';
                mid[0].style.width = bw - 13 + 'px';
            } else {
                left[0].style.width = bw - 50 + 'px';
                mid[0].style.width = '0px';
            }
        },
        selectemployee(type) {
            let that = this;
            that.$refs.employee.clearInput(true);
        },
        getemployee(data) {
            let that = this;
            if(that.dataDetail.Lists.length > 0){
                data = data.filter(item => {
                    return that.dataDetail.Lists.every(item2 => {
                        return item2.userID != item.code
                    })
                })
            }
            for (let i = 0; i < data.length; i++) {
                that.dataDetail.Lists = [
                    ...that.dataDetail.Lists,
                    {
                        UnNum: '',
                        Person: data[i].name,
                        userID: data[i].code,
                        loginName: data[i].loginname,
                    }
                ];
            }
        },
        handleSelectionChange(val) {
            let that = this;
            that.selectData = [];
            for (let i = 0; i < val.length; i++) {
                that.selectData.push(val[i].loginName);
            }
        },
        delbatch() {
            let that = this;
            let arr = that.dataDetail.Lists.filter(item => {
                return that.selectData.every(item2 => {
                    return item.loginName != item2;
                });
            });
            that.dataDetail.Lists = arr;
        },
        openEdit() {
            let that = this
            let left = document.getElementsByClassName('left');
            let mid = document.getElementsByClassName('mid');
            let Box = document.getElementsByClassName('Boxs');
            let bw = Box[0].clientWidth;
            left[0].style.width = '0px';
            mid[0].style.width = '100%';
        },
        colseEdit(){
            let that = this
            let left = document.getElementsByClassName('left');
            let mid = document.getElementsByClassName('mid');
            let Box = document.getElementsByClassName('Boxs');
            let bw = Box[0].clientWidth;
            left[0].style.width = '100%';
            mid[0].style.width = '0px'
        },
        tableRowClassName({ row, rowIndex }){
            let that = this
            if (row.personloginname && row.personloginname.indexOf(that.userData.Login_Code) !== -1) {
                return 'red';
            }
		},
		handleSizeChange(val) {
			this.pageSize = val;
			this.getView();
			this.authority();
		},
		handleCurrentChange(val) {
			this.pageIndex = val;
			this.getView();
			this.authority();
		},
		// 查询
		search() {
			let that = this;
			that.showSearch = true
			//that.getView();
		},
        editInfo(row){
            let that = this
			that.code = row.unnum
			that.getDetail(row.unnum)
		},
		getDetail(num){
            let that = this
            let parm = {
                unnum:num,
                conf_room:'',
            };
            let loadingInstance = Loading.service(Common.maskoption);
            that.$http.urlpost('/Conf/View/GetConfDetails', parm, function (res) {
                if (res.Success == 1) {
                    that.dataDetail = res.DataContent;
                    that.btnauthority();
                }
                loadingInstance.close()
            });
		},
        del(){
            let that = this
            this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
                confirmButtonText: that.$t('getapi[1146]'),
                cancelButtonText: that.$t('getapi[2054]'),
                type: 'warning'
            })
                .then(() => {
                    let parm = {
                        unnum:that.dataDetail.Head.unnum,
                        conf_room:'',
                    }
                    that.$http.urlpost('/Conf/View/DeleteConfWithPerson', parm, function (res) {
                        if (res.Success == 1) {
                            that.$message.success(that.$t('getapi[659]'));
                            that.getView()
							that.dataDetail={
                                Head:{unnum: '',
                                    conf_room: '',
                                    conf_date: '',
                                    conf_theme: '',
                                    conf_content: '',
                                    start_time: '',
                                    end_time: '',
                                    show_end_time: '',
                                    conf_num: 0,
                                    conf_device: '',
                                    status: 0,
                                    appt_tel: '',
                                    appt_percode: '',
                                    appt_person: '',
                                    appt_time: '',
                                    audit_person: '',
                                    audit_time: '',
                                    audit_opinion: '',
                                    remark: '',
                                    modify_time: '',
                                    create_time: '',
                                    datearr:[],},
                                Lists:[],
                            }
                            that.btnauthority()
                        }
                    });
                })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: that.$t('getapi[8574]')
                    });
                });
		},
        save() {
            let that = this;
            let parm = {
                Head:{
                    unnum: that.dataDetail.Head.unnum,
                    conf_room: that.dataDetail.Head.conf_room,
                    conf_theme: that.dataDetail.Head.conf_theme,
                    start_time: that.dataDetail.Head.start_time,
                    end_time: that.dataDetail.Head.end_time,
                    appt_tel: that.dataDetail.Head.appt_tel,
                    appt_person: that.dataDetail.Head.appt_person,
                    conf_date: that.dataDetail.Head.conf_date,
                    datelist1:'',
                    datelist2:'',
                    datelist3:'',
                    datelist4:'',
                    datelist5:'',
                    datelist6:'',
                    datelist7:'',
                },
                Lists: that.dataDetail.Lists
            };
            that.$http.urlpost('/Conf/View/EditConfWithPerson', parm, function (res) {
                if (res.Success == 1) {
                    that.$message.success(this.$t('getapi[284]'))
                    that.getDetail(that.code)
                }
            });
        },
		// 数据一览
		getView() {
			let that = this;
			let parm = {
                Page_Index:this.pageIndex,
                Page_Size:this.pageSize,
            	UnNum:that.UnNum,
                Conf_Theme:that.Conf_Theme,
                Conf_Room:that.Conf_Room,
                Status:'',
			}
			that.loading = true
			that.$http.urlpost('/Conf/View/ConfList', parm, function(res) {
				if (res.Success == 1) {
					that.dataSet = res.DataContent;
					that.total = res.Totals;
					that.loading = false;
				}
                that.loading = false
                that.showSearch = false
			});
		},
		// 刷新
		reflash() {
			let that = this;
			that.getView();
		},
	}
};
</script>

<style scoped lang="less">
table {
	border-collapse: separate;
	border-spacing: 0px 5px;
	td {
		padding-left: 3px;
		white-space: pre;
	}
}
/deep/.red{
	color: red;
}
</style>
